// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 650px) {
  .app-bar {
    grid-template-columns: 1fr auto;
    padding: 8px 32px;
  }

  .app-bar__brand h1 {
    font-size: 1.5em;
  }

  .app-bar__menu {
    display: none;
  }

  .app-bar__navigation {
    position: static;
    width: 100%;
  }

  .app-bar__navigation ul li {
    display: inline-block;
  }

  .app-bar__navigation ul li a {
    display: inline-block;
    width: 120px;
    text-align: center;
    margin: 0;
  }

  .movies {
    grid-template-columns: 1fr 1fr;
  }

  .movie {
    grid-template-columns: auto 1fr;
  }

  .movie__title {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .movie__overview {
    grid-column-start: 1;
    grid-column-end: 3;
  }
}

@media screen and (min-width: 800px) {
  .app-bar__brand h1 {
    font-size: 2em;
  }
}

@media screen and (min-width: 850px) {
  .movies {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (min-width: 1200px) {
  .movies {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (min-width: 1600px) {
  .movies {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (min-width: 768px) {
  .card-fav {
    width: calc(25% - 40px);
    box-sizing: border-box;
  }
}

@media (max-width: 767px) {
  .card-fav {
    width: calc(50% - 40px);
    box-sizing: border-box;
  }
}

@media (max-width: 576px) {
  .card-fav {
    width: calc(100% - 30px);
    box-sizing: border-box;
  }

  .card-fav .card-title a {
    font-size: 1rem;
  }

  .card-fav .rating {
    font-size: 1rem;
  }

  .card-fav .card-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .resto {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}

@media (max-width: 576px) {
  .content__heading {
    font-size: 1.5rem;
  }

  .card {
    padding: 15px;
  }

  .card-title a {
    font-size: 1.2rem;
  }

  .card-text {
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .navbar {
    display: 40%;
  }

  .hero-text {
    position: absolute;
    top: 44%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .hero-text h2 {
    font-size: 2rem;
  }

  .hero-text p {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .hero-text {
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .hero-text h2 {
    font-size: 1.7rem;
  }

  .hero-text p {
    font-size: 0.9rem;
  }

  .hamburger {
    display: block;
  }

  .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }

  .hamburger.active .bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }

  .hamburger.active .bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }

  .nav-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    gap: 0;
    flex-direction: column;
    background-color: #776B5D;
    width: 100%;
    text-align: center;
    transition: 0.3s;
  }

  .nav-item {
    margin: 16px 0;
  }

  .nav-menu.active {
    left: 0;
    z-index: 100;
  }
}

@media screen and (min-width: 650px) {
  .app-bar {
    grid-template-columns: 1fr auto;
    padding: 8px 32px;
  }

  .app-bar__brand h1 {
    font-size: 1.5em;
  }

  .app-bar__menu {
    display: none;
  }

  .app-bar__navigation {
    position: static;
    width: 100%;
  }

  .app-bar__navigation ul li {
    display: inline-block;
  }

  .app-bar__navigation ul li a {
    display: inline-block;
    width: 120px;
    text-align: center;
    margin: 0;
  }
}
@media (min-width: 768px) {

  .card-detail, .card-detail-rev {
    margin: 0;
    grid-template-columns: 1fr 1fr; 
  }
}

@media (min-width: 1024px) {
  .card-detail {
    width: 48%;
  }

  .card-detail-rev {
    width: 100%; 
    max-width: 1136px; 
  }
}

@media (min-width: 1440px) {
  .card-detail {
    width: 32%; 
  }
}
@media (max-width: 768px) {
  .card-detail, .card-detail-rev {
    max-width: 100%;
    margin: 12px 0; 
  }

  .menu {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,MAAM;IACN,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,YAAY;EACd;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;AACF;AACA;;EAEE;IACE,SAAS;IACT,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@media screen and (min-width: 650px) {\n  .app-bar {\n    grid-template-columns: 1fr auto;\n    padding: 8px 32px;\n  }\n\n  .app-bar__brand h1 {\n    font-size: 1.5em;\n  }\n\n  .app-bar__menu {\n    display: none;\n  }\n\n  .app-bar__navigation {\n    position: static;\n    width: 100%;\n  }\n\n  .app-bar__navigation ul li {\n    display: inline-block;\n  }\n\n  .app-bar__navigation ul li a {\n    display: inline-block;\n    width: 120px;\n    text-align: center;\n    margin: 0;\n  }\n\n  .movies {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .movie {\n    grid-template-columns: auto 1fr;\n  }\n\n  .movie__title {\n    grid-column-start: 1;\n    grid-column-end: 3;\n  }\n\n  .movie__overview {\n    grid-column-start: 1;\n    grid-column-end: 3;\n  }\n}\n\n@media screen and (min-width: 800px) {\n  .app-bar__brand h1 {\n    font-size: 2em;\n  }\n}\n\n@media screen and (min-width: 850px) {\n  .movies {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .movies {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media screen and (min-width: 1600px) {\n  .movies {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (min-width: 768px) {\n  .card-fav {\n    width: calc(25% - 40px);\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 767px) {\n  .card-fav {\n    width: calc(50% - 40px);\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 576px) {\n  .card-fav {\n    width: calc(100% - 30px);\n    box-sizing: border-box;\n  }\n\n  .card-fav .card-title a {\n    font-size: 1rem;\n  }\n\n  .card-fav .rating {\n    font-size: 1rem;\n  }\n\n  .card-fav .card-text {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .resto {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  }\n}\n\n@media (max-width: 576px) {\n  .content__heading {\n    font-size: 1.5rem;\n  }\n\n  .card {\n    padding: 15px;\n  }\n\n  .card-title a {\n    font-size: 1.2rem;\n  }\n\n  .card-text {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    display: 40%;\n  }\n\n  .hero-text {\n    position: absolute;\n    top: 44%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n  }\n\n  .hero-text h2 {\n    font-size: 2rem;\n  }\n\n  .hero-text p {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .hero-text {\n    position: absolute;\n    top: 35%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n  }\n\n  .hero-text h2 {\n    font-size: 1.7rem;\n  }\n\n  .hero-text p {\n    font-size: 0.9rem;\n  }\n\n  .hamburger {\n    display: block;\n  }\n\n  .hamburger.active .bar:nth-child(2) {\n    opacity: 0;\n  }\n\n  .hamburger.active .bar:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n  }\n\n  .hamburger.active .bar:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n  }\n\n  .nav-menu {\n    position: fixed;\n    left: -100%;\n    top: 70px;\n    gap: 0;\n    flex-direction: column;\n    background-color: #776B5D;\n    width: 100%;\n    text-align: center;\n    transition: 0.3s;\n  }\n\n  .nav-item {\n    margin: 16px 0;\n  }\n\n  .nav-menu.active {\n    left: 0;\n    z-index: 100;\n  }\n}\n\n@media screen and (min-width: 650px) {\n  .app-bar {\n    grid-template-columns: 1fr auto;\n    padding: 8px 32px;\n  }\n\n  .app-bar__brand h1 {\n    font-size: 1.5em;\n  }\n\n  .app-bar__menu {\n    display: none;\n  }\n\n  .app-bar__navigation {\n    position: static;\n    width: 100%;\n  }\n\n  .app-bar__navigation ul li {\n    display: inline-block;\n  }\n\n  .app-bar__navigation ul li a {\n    display: inline-block;\n    width: 120px;\n    text-align: center;\n    margin: 0;\n  }\n}\n@media (min-width: 768px) {\n\n  .card-detail, .card-detail-rev {\n    margin: 0;\n    grid-template-columns: 1fr 1fr; \n  }\n}\n\n@media (min-width: 1024px) {\n  .card-detail {\n    width: 48%;\n  }\n\n  .card-detail-rev {\n    width: 100%; \n    max-width: 1136px; \n  }\n}\n\n@media (min-width: 1440px) {\n  .card-detail {\n    width: 32%; \n  }\n}\n@media (max-width: 768px) {\n  .card-detail, .card-detail-rev {\n    max-width: 100%;\n    margin: 12px 0; \n  }\n\n  .menu {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
